import { Select } from "antd";

interface PermissionsFormProps {
  onChange: (e: any) => void;
  formData: any;
}

export const PermissionsForm: React.FC<PermissionsFormProps> = ({
  onChange,
  formData,
}) => {
  const handleOnFormChange = (id: string, value: any) => {
    onChange({ target: { id, value } });
  };

  const options = [
    { label: "Nenhuma", value: "NONE" },
    { label: "Visualizar", value: "VIEW" },
    { label: "Usuário", value: "USER" },
    { label: "Administrador", value: "ADMIN" },
  ];

  return (
    <div>
      <p>Ações de Gerencia</p>
      <Select
        id="management"
        onChange={(value) => handleOnFormChange("management", value)}
        value={formData.management}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Gerenciamento de Regiões</p>
      <Select
        id="region_management"
        onChange={(value) => handleOnFormChange("region_management", value)}
        value={formData.region_management}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Fluxo de Checklist</p>
      <Select
        id="checklist"
        onChange={(value) => handleOnFormChange("checklist", value)}
        value={formData.checklist}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Fluxo de Medição</p>
      <Select
        id="measuring"
        onChange={(value) => handleOnFormChange("measuring", value)}
        value={formData.measuring}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Fluxo de Montagem</p>
      <Select
        id="assemble"
        onChange={(value) => handleOnFormChange("assemble", value)}
        value={formData.assemble}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Ações Avançadas do Fluxo de Montagem</p>

      <Select
        id="assemble_actions"
        onChange={(value) => handleOnFormChange("assemble_actions", value)}
        value={formData.assemble_actions}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Assitência Técnica</p>
      <Select
        id="support"
        onChange={(value) => handleOnFormChange("support", value)}
        value={formData.support ?? "NONE"}
        style={{ width: "100%" }}
        options={options.filter(
          ({ value }) => value === "NONE" || value === "USER"
        )}
      />
      <p>Pagamentos</p>
      <Select
        id="payments"
        onChange={(value) => handleOnFormChange("payments", value)}
        value={formData.payments ?? "NONE"}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Calendários</p>
      <Select
        id="calendar"
        onChange={(value) => handleOnFormChange("calendar", value)}
        value={formData.calendar}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Usuários</p>
      <Select
        id="users"
        onChange={(value) => handleOnFormChange("users", value)}
        value={formData.users}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Financeiro</p>
      <Select
        id="financial"
        onChange={(value) => handleOnFormChange("financial", value)}
        value={formData.financial}
        style={{ width: "100%" }}
        options={options}
      />
      <p>Applicativo Medição</p>
      <Select
        id="app"
        onChange={(value) => handleOnFormChange("app", value)}
        value={formData.app}
        style={{ width: "100%" }}
        options={options.filter(
          ({ value }) => value === "NONE" || value === "USER"
        )}
      />
      <p>Aplicativo Montagem</p>
      <Select
        id="assemble_app"
        onChange={(value) => handleOnFormChange("assemble_app", value)}
        value={formData.assemble_app || "NONE"}
        style={{ width: "100%" }}
        options={options.filter(
          ({ value }) => value === "NONE" || value === "USER"
        )}
      />
    </div>
  );
};
